import request from '@/utils/request'

let IndexApi = {
    getProgress(data, errorback) {
        return request._get('/shop/setting.store/buildStoreStepStatus', data, errorback);
    }
}

export default IndexApi;


// WEBPACK FOOTER //
// ./src/api/buildstore.js